/**
 * Customer 360 API service.
 *
 * Provides methods for customer list and 360 profile endpoints.
 */

import api from './api';
import type {
  Customer360Profile,
  CustomerListResponse,
  RegionalResponsibleOption,
} from '../types/customer';

export interface CustomerListParams {
  search?: string;
  salesperson_no?: string;
  regional_responsible?: string;
  state?: string;
  status?: string;
  my_customers?: boolean;
  sort_by?: string;
  sort_dir?: string;
  limit?: number;
  offset?: number;
}

export const customerService = {
  /**
   * List customers with optional search and filters.
   */
  async listCustomers(params: CustomerListParams = {}): Promise<CustomerListResponse> {
    const { data } = await api.get<CustomerListResponse>('/customers', { params });
    return data;
  },

  /**
   * List the distinct regional responsibles (core salespeople) for filtering.
   */
  async listRegionalResponsibles(): Promise<RegionalResponsibleOption[]> {
    const { data } = await api.get<RegionalResponsibleOption[]>(
      '/customers/regional-responsibles'
    );
    return data;
  },

  /**
   * Get the full Customer 360 profile by slug.
   */
  async getProfile(slug: string): Promise<Customer360Profile> {
    const { data } = await api.get<Customer360Profile>(`/customers/${slug}`);
    return data;
  },
};
